import axios from 'axios'

// console.log((window.location.href).indexOf("m2.xcdtech.net"))
axios.defaults.baseURL = (window.location.href).indexOf("m2.xcdtech.net") !== -1?'https://gateway-center.xcdtech.net':'https://gateway-center-test.xcdtech.net'

const service = axios.create({
  timeout: 40000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=UTF-8'
  },
})
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
  }
)
export default service



// WEBPACK FOOTER //
// ./src/modules/verifition/utils/axios.js